/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timecode: NonNullable<unknown> }} Audio_Description_Export_Status_Combining_Segments_ProgressInputs */



/**
* | output |
* | --- |
* | "Combining segments... {timecode}" |
*
* @param {Audio_Description_Export_Status_Combining_Segments_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_combining_segments_progress = /** @type {((inputs: Audio_Description_Export_Status_Combining_Segments_ProgressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Combining_Segments_ProgressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Assemblage des segments... ${i?.timecode}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Segmente werden kombiniert... ${i?.timecode}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Combinazione dei segmenti... ${i?.timecode}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Объединение сегментов... ${i?.timecode}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Combinando segmentos... ${i?.timecode}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`合并片段... ${i?.timecode}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`セグメントを結合しています... ${i?.timecode}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`खंडों का संयोजन... ${i?.timecode}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Combinando segmentos... ${i?.timecode}`)
	return /** @type {LocalizedString} */ (`Combining segments... ${i?.timecode}`)
});